import AuthMiddleware from "@/middleware/auth"

function lazyLoad(view) {
  return () => import(`@/views/cases/${view}.vue`)
}
const CaseRouter = [
  {
    path: "/all-cases",
    name: "AllCases",
    component: lazyLoad("AllCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "ALL CASES",
    },
  },
  {
    path: "/all-cases/active",
    name: "ActiveCases",
    beforeEnter: AuthMiddleware.user,
    component: lazyLoad("ActiveCases"),
    meta: {
      title: "ALL CASES",
    },
  },
  {
    path: "/all-cases/pending",
    name: "PendingCases",
    beforeEnter: AuthMiddleware.user,
    component: lazyLoad("PendingCases"),
    meta: {
      title: "ALL CASES",
    },
  },
  {
    path: "/all-cases/finalized",
    name: "CompleteCases",
    beforeEnter: AuthMiddleware.user,
    component: lazyLoad("CompleteCases"),
    meta: {
      title: "ALL CASES",
    },
  },
  {
    path: "/all-cases/archive",
    name: "ArchiveCase",
    beforeEnter: AuthMiddleware.user,
    component: lazyLoad("ArchiveCase"),
    meta: {
      title: "ALL CASES",
    },
  },
  {
    path: "/all-cases/rejected",
    name: "RejectedCases",
    beforeEnter: AuthMiddleware.user,
    component: lazyLoad("RejectionCases"),
    meta: {
      title: "ALL CASES",
    },
  },
  {
    path: "/validation-cases",
    name: "ValidationCases",
    beforeEnter: AuthMiddleware.user,
    component: lazyLoad("IsValidationCases"),
    meta: {
      title: "VALIDATION CASES",
    },
  },
  {
    path: "/all-cases/pending-list",
    name: "PendingCasesList",
    beforeEnter: AuthMiddleware.user,
    component: lazyLoad("PendingCasesList"),
    meta: {
      title: "ALL CASES",
    },
  },
  {
    path: "/cases/:case_id",
    name: "CaseView",
    component: lazyLoad("ViewCase"),
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/all-billing-cases/pending",
    name: "AllPendingBilledCases",
    component: lazyLoad("AllBilledCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "Unbilled Cases",
    },
  },
  {
    path: "/all-billing-cases/billed",
    name: "BilledCases",
    component: lazyLoad("StatusBasedBilledCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "Billed Cases",
    },
  },
  {
    path: "/all-billing-cases/client-billed",
    name: "ClientBilledCases",
    component: lazyLoad("ClientCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "Client Cases",
    },
  },
  {
    path: "/all-billing-cases/exception-billed",
    name: "ExceptionBilledCases",
    component: lazyLoad("ExceptionBilledCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "Exception Cases",
    },
  },
  {
    path: "/all-billing-cases/on-hold",
    name: "OnholdBilledCases",
    component: lazyLoad("OnholdBilledCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "Onhold Cases",
    },
  },
  {
    path: "/all-billing-cases/billed-exception",
    name: "BilledExceptionBilledCases",
    component: lazyLoad("BilledWithException"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "Billed With Exception Cases",
    },
  },
  {
    path: "/all-billing-cases/billed-patient-claim",
    name: "BilledPatientBilledCases",
    component: lazyLoad("BilledWithPatient"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "Billed With Patient Claim Cases",
    },
  },
  {
    path: "/all-billing-cases/coding",
    name: "CodingCases",
    component: lazyLoad("CodingCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "CODING CASES",
    },
  },
  {
    path: "/all-billing-cases/exception-resolved",
    name: "ExceptionResolvedCases",
    component: lazyLoad("ExceptionResolvedCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "EXCEPTION RESOLVED",
    },
  },
  {
    path: "/all-billing-cases/exception-reviewed",
    name: "ExceptionReviewedCases",
    component: lazyLoad("ExceptionReviewedCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "EXCEPTION REVIEWED",
    },
  },
  {
    path: "/all-cases/replaced-insurance",
    name: "ReplacedInsurance",
    component: lazyLoad("ReplacedCases"),
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "EXCEPTION REVIEWED",
    },
  },
  {
    path: "/case-info/:case_id/edit",
    name: "Case-Information-Update",
    component: lazyLoad("NewPatientCase"),
    beforeEnter: AuthMiddleware.user,
  },
]

export { CaseRouter }
